import React, { useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, Linking, Platform } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '../../lib/contexts/AuthContext';
import { DynamicTitle } from '../DynamicTitle';
import { enableLocationBypassForDevTesting, setLocationVerifiedThisSession } from '../../lib/utils/locationAvailability';

export function ComensalUbicacionRequeridaPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/entrar', { replace: true });
    }
  }, [loading, user, navigate]);

  const handleReintentar = async () => {
    await setLocationVerifiedThisSession(false);
    navigate('/', { replace: true });
  };

  const handleBypassDev = async () => {
    await enableLocationBypassForDevTesting();
    navigate('/', { replace: true });
  };

  if (loading || !user) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#030213" />
      </View>
    );
  }

  return (
    <View style={styles.screen}>
      <DynamicTitle title="Ubicación requerida — As Gastronómico" />
      <View style={styles.iconWrap}>
        <Ionicons name="location-off-outline" size={56} color="#b91c1c" />
      </View>
      <Text style={styles.title}>Necesitamos tu ubicación</Text>
      <Text style={styles.body}>
        Esta parte de la app está pensada para mostrarte contenido y tu ciudad según donde estés. Activa el GPS y concede permiso de
        ubicación al navegador o a la app para continuar.
      </Text>
      <Text style={styles.hint}>
        Si ya lo habías activado, revisa que no esté desactivado el GPS del dispositivo ni el permiso del sitio en los ajustes del
        navegador.
      </Text>

      <TouchableOpacity style={styles.primaryBtn} onPress={handleReintentar} activeOpacity={0.85}>
        <Ionicons name="refresh-outline" size={22} color="#ffffff" style={styles.btnIcon} />
        <Text style={styles.primaryBtnText}>Comprobar de nuevo</Text>
      </TouchableOpacity>

      {Platform.OS !== 'web' ? (
        <TouchableOpacity
          style={styles.secondaryBtn}
          onPress={() => Linking.openSettings()}
          activeOpacity={0.85}
        >
          <Text style={styles.secondaryBtnText}>Abrir ajustes del sistema</Text>
        </TouchableOpacity>
      ) : null}

      <TouchableOpacity style={styles.bypassBtn} onPress={handleBypassDev} activeOpacity={0.75}>
        <Text style={styles.bypassText}>Bypass ubicación (pruebas)</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: '#ffffff',
    paddingHorizontal: 24,
    paddingTop: 48,
    paddingBottom: 32,
  },
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  iconWrap: {
    alignSelf: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: '#030213',
    textAlign: 'center',
    marginBottom: 12,
  },
  body: {
    fontSize: 15,
    color: '#374151',
    lineHeight: 22,
    textAlign: 'center',
    marginBottom: 16,
  },
  hint: {
    fontSize: 13,
    color: '#6b7280',
    lineHeight: 19,
    textAlign: 'center',
    marginBottom: 28,
  },
  primaryBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#030213',
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 10,
    marginBottom: 12,
  },
  btnIcon: {
    marginRight: 8,
  },
  primaryBtnText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  secondaryBtn: {
    alignItems: 'center',
    paddingVertical: 12,
  },
  secondaryBtnText: {
    color: '#2563eb',
    fontSize: 15,
    fontWeight: '600',
  },
  bypassBtn: {
    marginTop: 24,
    alignItems: 'center',
    paddingVertical: 8,
  },
  bypassText: {
    fontSize: 13,
    color: '#9ca3af',
    textDecorationLine: 'underline',
  },
});
